import { As, CardProps, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { Card, CardBody, CardHeader } from 'ui-components/dist/Card';
import { CopyIcon } from 'ui-components/dist/CopyIcon';

interface Props extends CardProps {
  title: string;
  description: string;
  icon: As;
}

export const ViewCard: React.FC<Props> = ({
  title,
  description,
  icon,
  ...props
}) => (
  <Card width={{ base: '100%' }} cursor="pointer" {...props}>
    <CardHeader>
      <Flex width="100%" backgroundColor="neutral.100" justifyContent="center">
        <Icon width="auto" height={20} as={icon} />
      </Flex>
    </CardHeader>
    <CardBody>
      <Flex width="100%" direction="column" alignItems="flex-start">
        <Heading
          marginTop={4}
          as="h3"
          size="lg"
          fontSize="lg"
          fontWeight="medium"
          lineHeight="4.5"
        >
          {title}
        </Heading>
        <Flex justifyContent="space-between" alignItems="flex-end" width="100%">
          <Text
            marginTop={1}
            maxWidth={{ base: '100%', sm: 40 }}
            as="p"
            fontSize="sm"
            lineHeight={3.5}
            color="primary.300"
            textAlign="left"
            whiteSpace="break-spaces"
          >
            {description}
          </Text>

          <CopyIcon boxSize={4} />
        </Flex>
      </Flex>
    </CardBody>
  </Card>
);
